export default __webpack_public_path__ + "static/media/1040.ac9b43b8.jpeg";